<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :fullscreen="fullscreen"
    :destroy-on-close="true"
    :title="'预案' | translateTo(this.i18n)"
    top="0"
    width="55vw"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    class="custom-preview-container"
  >
    <iframe class="preview-iframe" :src="url" />
  </el-dialog>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      i18n: 'layout'
    };
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      done?.();
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.custom-preview-container {
  .preview-iframe {
    width: 100%;
    height: 100%;
  }

  .el-dialog {
    .el-dialog__body {
      box-sizing: border-box;
      height: calc(100% - 54px);
    }
  }
}
</style>
